// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2c8f7355","455":"c5fd3d80"}[chunkId] + ".chunk.js";
};